import React, { useEffect, useState, useRef } from "react";
import API from "../../services/api";
import ScrollContainer from "react-indiana-drag-scroll";
import NoDataFound from "../../shared/NoDataFound";
import { formatDatewithMonthReadable } from "../../utils/dateFormat";
import {languageOptions,formatAmount} from "../../utils/constants";
import {slotPaymentTypeOptions} from "../../utils/constants";
import TableLoader from "../../shared/TableLoader";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";


const InboundSaleCampaigns = ({team})=>{

    const [data,setdata]=useState([]);
    const [TotalPrice,setTotalPrice]=useState("");
    const [loader,setloader]=useState(false);
    const [downloader,setDownloader]=useState(false);
    const csvLinkRef = useRef();
    
    const TomorrowRunningCampaigns = (reportType)=>{
      if(!data.length)
      {
        toast.info("No data to Download");
        return;
      }
      setDownloader(true);
      csvLinkRef?.current?.link?.click();
      setTimeout(() => {
        setDownloader(false);
      }, 3000);
      }
      const Headers = [
        { label: "Date of Campaign", key: "start_date" },
        { label: "Team Name", key: "team" },
        { label: "Brand Name", key: "company_name" },
        { label: "District", key: "company_dist_name" },
        { label: "AD Placement", key: "ad_placement" }, 
        { label: "AD Location", key: "ad_location" }, 
        { label: "POS", key: "position" },
        { label: "AD Format", key: "sub_type" },
        { label: "Price", key: "price" },
        { label: "Payment Status", key: "payment_status" }, 
        { label: "Packages", key: "packages" },
        { label: "New / Old.", key:"rank"}
    ];
    const fetchData = async()=>{
        try{
            setloader(true);
            let res = await API({
                url:"/reports/campaignsRunningTomorrow",
                method:'POST',
                responseType:'json',
                data:{
                  team:team
                }
              })
              if(res.code === 200)
              {
                setdata(res.data?.result);
                setTotalPrice(res.data?.totalSalesPrice)
              }
            setloader(false);

        }catch(error)
        {
            console.error(error);
            setloader(false);
        }
    }
    useEffect(()=>{
    fetchData();
    },[])

    
    return (
        <div >
        <div className="flex flex-col items-end">
        <sl-tooltip content="Download" hoist>
                    <sl-icon-button
                        library="lucide"
                        name="download"
                        onClick={() => {
                            TomorrowRunningCampaigns();
                        }}
                        className="top-4 right-4"
                    ></sl-icon-button>
        </sl-tooltip>
        <CSVLink
        data={[...data.map(({
            start_date,
            company_name,
            company_dist_name,
            team,
            mandal_ids,
            district_ids,
            constituency_ids,
            state_ids,
            lang_ids,
            position,
            sub_type,
            campaign_type,
            cpd,
            daily_budget,
            payment_type,
            payment_details,
            package_type,
            lineitem_rank,
            package_weeks
        })=>{
            const adPlacement =constituency_ids.length > 0
            ? "Constituency"
            : mandal_ids.length > 0
                ? "Mandal"
                :  district_ids.length > 0
                ? "District"
                : state_ids.length > 0
                ? "State"
                : "Language";

            const adLocation = constituency_ids.length > 0
            ? constituency_ids.map(item => item.const_name || item.id).join(', ') 
            :mandal_ids.length > 0
                ? mandal_ids.map(item => item.mandal_name || item.id).join(', ') 
                :  district_ids.length > 0
                ? district_ids.map(item => item.dist_name || item.id).join(', ')  
                : state_ids.length > 0
                ? state_ids.map(item => item.state_name || item.id).join(', ')  
                : lang_ids.length > 0
                ? lang_ids.map(id => languageOptions.find(option => option.value === id)?.label).filter(Boolean).join(', ')  
                : "No Data";


            return {
                start_date,
                team,
                company_name,
                company_dist_name,
                ad_placement:adPlacement,
                ad_location:adLocation,
                position:+position,
                sub_type,
                price: campaign_type === "CPD" ? +cpd : +daily_budget,
                payment_status: payment_type === 1 ? payment_details.cheque_no : (slotPaymentTypeOptions.find(option => option.value === payment_type) || {}).label || "",
                packages: package_type ? package_type : 'No' , 
                rank: package_type ? +lineitem_rank === 1 ? 'New' : 'Old' : '-' , 
                package_weeks:package_weeks ? `${package_weeks} Weeks` : '-'
            };
        }),{
            start_date: "",
            team: "",
            company_name: "",
            company_dist_name:"",
            ad_placement: "",
            ad_location: "",
            position: "",
            sub_type: "TotalPrice",
            price: parseFloat(TotalPrice).toFixed(2), 
            payment_status: "",
            packages: "",
            rank:"",
            package_weeks:""
        }]}
        headers={Headers}
        filename="CentralizedInboundSales.csv"
        ref={csvLinkRef}
        style={{ display: "none" }} // Hide from UI
        />
        </div>
        <div className="report-image">
          <ScrollContainer>
          <table  className='table table-bordered font-bold report-table'>
            <thead> 
                <tr className="!bg-blue-500 !text-white text-center">
                        <th>Date of Campaign</th>
                        <th>Team Name</th>
                        <th>Brand Name</th>
                        <th>District</th>
                        <th>AD Placement</th>
                        <th>AD Location</th>
                        <th>POS</th>
                        <th>AD Format</th>
                        <th>Price</th>
                        <th>Payment status</th>
                        <th>Packages</th>
                        <th>Package Weeks</th>
                        <th>New / Old.</th>
                </tr>
            </thead>
            {data.length > 0 ? (
            <tbody>
           { data.map((row,index)=>{

               const date = formatDatewithMonthReadable(row.start_date);
                return (
                    <tr>
                        <td>{date}</td>
                        <td>{row.team}</td>
                        <td>{row.company_name}</td>
                        <td>{row.company_dist_name}</td>
                        <td>
                            {
                             row.constituency_ids.length > 0
                             ? "Constituency"
                             :row.mandal_ids.length > 0
                            ? "Mandal"
                            :  row.district_ids.length > 0
                            ? "District"
                            : row.state_ids.length > 0
                            ? "State"
                            : "Language"
                            }
                        </td>
                        <td>
                        {
                            row.constituency_ids.length > 0
                            ? row.constituency_ids.map(item => item.const_name || item.id).join(', ') 
                            :row.mandal_ids.length > 0
                            ? row.mandal_ids.map(item => item.mandal_name || item.id).join(', ') 
                            :  row.district_ids.length > 0
                            ? row.district_ids.map(item => item.dist_name || item.id).join(', ')  
                            : row.state_ids.length > 0
                            ? row.state_ids.map(item => item.state_name || item.id).join(', ')  
                            : row.lang_ids.length > 0
                            ? row.lang_ids.map(id => languageOptions.find(option => option.value === id)?.label)  
                            .filter(Boolean)
                            .join(', ')  
                        : "No Data"
                        }
                        </td>
                        <td>{row.position}</td>
                        <td>{row.sub_type}</td>
                        <td title={row.campaign_type === "CPD" ? row.cpd : row.daily_budget}>
                            ₹{formatAmount(row.campaign_type === "CPD" ? row.cpd : row.daily_budget)}
                        </td>
                        <td>
                            {
                            row.payment_type === 1 
                            ? row.payment_details.cheque_no 
                            : (slotPaymentTypeOptions.find(option => option.value === row.payment_type) || {}).label || ""
                            }
                        </td>
                        <td>{row.package_type ? row.package_type : 'No'}</td>
                        <td className="!bg-orange-300">{row.package_weeks ? `${row.package_weeks} Weeks` : '-'}</td>
                        <td className="!bg-green-300">{row.package_type ? +row.lineitem_rank === 1 ? 'New' : 'Old' : '-'}</td>
                    </tr>
                    
                )
            })}
            <tr>
            <td colSpan="7"  className="px-4 py-2 text-center font-bold">Inbond Sales Total</td>
            <td colSpan="5"  className="px-4 py-2 text-center font-bold !bg-yellow-200">{TotalPrice}</td>
            </tr>
            </tbody>
           ): !data?.length && !loader ? (
           <NoDataFound colspan="12" />
           ) : (
            <TableLoader colspan="12" />
        )
         }
          </table>
          </ScrollContainer>
        </div>
    </div>
    )
}
export default InboundSaleCampaigns;